var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8 0H1.2C0.54 0 0 0.54 0 1.2V13.6C0 14.92 1.08 16 2.4 16H17.6C18.92 16 20 14.92 20 13.6V1.2C20 0.54 19.46 0 18.8 0ZM3.65 2.3C3.5502 2.21464 3.43456 2.14978 3.30968 2.10911C3.18481 2.06844 3.05315 2.05276 2.92222 2.06298C2.79129 2.07319 2.66365 2.1091 2.5466 2.16864C2.42954 2.22818 2.32536 2.3102 2.24 2.41C2.15464 2.5098 2.08978 2.62544 2.04911 2.75032C2.00844 2.87519 1.99276 3.00685 2.00298 3.13778C2.01319 3.26871 2.0491 3.39635 2.10864 3.5134C2.16818 3.63046 2.2502 3.73464 2.35 3.82L9.22 9.71C9.4378 9.8948 9.71437 9.99586 10 9.995C10.2858 9.99558 10.5623 9.89416 10.78 9.709L17.65 3.819C17.7554 3.73543 17.8428 3.63146 17.9071 3.51331C17.9713 3.39516 18.0111 3.26527 18.024 3.13139C18.0369 2.99752 18.0227 2.86242 17.9821 2.73418C17.9416 2.60594 17.8756 2.48719 17.7882 2.38504C17.7007 2.28288 17.5935 2.19943 17.473 2.13966C17.3525 2.07989 17.2212 2.04505 17.0869 2.0372C16.9527 2.02935 16.8182 2.04867 16.6916 2.094C16.565 2.13933 16.4488 2.20973 16.35 2.301L10 7.744L3.65 2.3Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e402ce0f5b979defee93fcb60a85d9d8.svg";
export { ForwardRef as ReactComponent };